import { render, staticRenderFns } from "./ApprovalTypes.vue?vue&type=template&id=9473f2d8"
import script from "./ApprovalTypes.vue?vue&type=script&lang=js"
export * from "./ApprovalTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports